let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("9zLwF"), load("arhgZ"), load("55DHm")]).then(() => parcelRequire('5JaU6'));